"use client";

import { useLayoutEffect } from "react";

/** Written to `document.documentElement` so fixed overlays (e.g. Sierra chat) can clear the mini cart. */
export const MINI_CART_BOTTOM_OFFSET_VAR = "--mini-cart-bottom-offset";

export function MiniCartBottomInsetSync() {
  useLayoutEffect(() => {
    const el = document.getElementById("mini-cart");
    const root = document.documentElement;

    if (!el) {
      return;
    }

    const apply = () => {
      const height = el.getBoundingClientRect().height;
      root.style.setProperty(
        MINI_CART_BOTTOM_OFFSET_VAR,
        `${Math.round(height)}px`,
      );
    };

    apply();

    const resizeObserver =
      typeof ResizeObserver !== "undefined" ? new ResizeObserver(apply) : null;
    resizeObserver?.observe(el);
    el.addEventListener("toggle", apply);

    return () => {
      resizeObserver?.disconnect();
      el.removeEventListener("toggle", apply);
      root.style.removeProperty(MINI_CART_BOTTOM_OFFSET_VAR);
    };
  }, []);

  return null;
}
